import React from "react";

export default function HeaderComponent() {
    return (
        <div>
            {/* Header Image */}
            <div className="mb-20">
                <img
                    className="object-cover w-full"
                    style={{
                        height: "700px",
                    }}
                    src="https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/pabloo%2Fmedia%2Fimage01.png?alt=media&token=eb7459db-0760-4d92-831b-70fc6ba2ff2f"
                    alt="Header Banner"
                />
                <style>
                    {`
                    @media (max-width: 767px) {
                        img[alt="Header Banner"] {
                            height: 400px !important;
                        }
                    }
                    `}
                </style>
            </div>

            {/* Text Block */}
            <div className="flex items-center justify-center">
                <div className="text-center text-black space-y-16" id="header-text-block">
                    <h1
                        className="text-[80px]"
                        id="header-title"
                        style={{
                            fontWeight: "600",
                            fontSize: "80px",
                            lineHeight: "1.2",
                        }}
                    >
                        <div>The elite memberships you love.</div>
                        <div>From an app you can trust.</div>
                    </h1>

                    <p
                        className="font-semibold text-3xl px-80"
                        id="header-subtext"
                        style={{
                            lineHeight: "1.2",
                        }}
                    >
                        Earn rewards effortlessly on every purchase, with instant payouts at top retailers. Backed by
                        256-bit encryption and fraud protection, so earnings and data are secure.
                    </p>
                </div>

                {/* Responsive Styles */}
                <style>
                    {`
                    @media (max-width: 767px) {
                        #header-title {
                            font-size: 32px !important;
                            line-height: 1.2 !important;
                        }

                        #header-subtext {
                            font-size: 16px !important;
                            padding-left: 2.5rem !important;
                            padding-right: 2.5rem !important;
                        }

                        #header-text-block > * + * {
                            margin-top: 1.5rem !important;
                        }
                    }
                    `}
                </style>
            </div>
        </div>
    );
}
